import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { COLORS } from '~/styles/colors';

import { ProgressBox } from './styled';

type ProgressComponentProps = CircularProgressProps & {
  value: number;
};

function ProgressComponent({ value, ...rest }: ProgressComponentProps) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" sx={{ color: COLORS.purple }} value={value} {...rest} />
      <ProgressBox>
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(value)}`}
        </Typography>
      </ProgressBox>
    </Box>
  );
}

export default ProgressComponent;
